import styled from 'styled-components'
import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import Button from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const SingleVoucherWrapper = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px;
`

interface SingleVoucherRowProps {
    isBorder?: boolean
}

export const SingleVoucherRow = styled(Box)<SingleVoucherRowProps>`
    border-bottom: ${(props) => (props.isBorder ? '2px solid' : 'none')};
    border-color: ${({ theme }) => theme.colors.grayscale_300};
`

interface SingleVoucherTextProps {
    fB?: string
    isEnd?: true
}

export const SingleVoucherText = styled(Text)<SingleVoucherTextProps>`
    flex-basis: ${(props) => (props.fB ? `${props.fB}%` : '50%')};
    text-align: ${({ isEnd }) => (isEnd ? 'end' : 'start')};
`

export const SingleVoucherIconButton = styled(Button)`
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 0;
    cursor: pointer;
    gap: 8px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.secondary_500};

    @media ${respondAbove.xl} {
        font-size: 16px;
    }
`
